<template>
  <div>
    <br />
    <vs-row vsW="12" style="margin-bottom: 10px">
      <vs-col
        vsType="flex"
        vsJustify="center"
        vsAlign="center"
        vsLg="2"
        vsSm="4"
        vsXs="12"
      ></vs-col>
      <vs-col
        vsType="flex"
        vsJustify="center"
        vsAlign="center"
        vsLg="2"
        vsSm="2"
        vsXs="12"
      ></vs-col>
      <vs-col
        vsType="flex"
        vsJustify="center"
        vsAlign="center"
        vsLg="2"
        vsSm="2"
        vsXs="12"
      ></vs-col>
      <vs-col
        vsType="flex"
        vsJustify="center"
        vsAlign="center"
        vsLg="2"
        vsSm="2"
        vsXs="12"
      ></vs-col>
      <vs-col
        vsType="flex"
        vsJustify="flex-end"
        vsAlign="flex-end"
        vsLg="4"
        vsSm="4"
        vsXs="12"
      >
        <vs-button
          id="selecttime"
          class="mt-3 w-1/3"
          icon-pack="feather"
          icon="icon-printer"
          @click="print()"
          >Print</vs-button
        >
      </vs-col>
    </vs-row>
    <div id="printMe" class="testtest">
      <center>
        <table>
          <tbody>
            <tr>
              <td class="pr-5">
                <img
                  src="https://upload.wikimedia.org/wikipedia/th/0/01/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%AA%E0%B8%A3%E0%B8%A3%E0%B8%9E%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B4%E0%B8%95.png"
                  alt
                  width="100px"
                  height="110px"
                />
              </td>
              <td>
                <center>
                  <h2>รายงานระบบตรวจสอบเฝ้าระวังการจำหน่ายน้ำมัน</h2>
                  <h3>สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร</h3>
                </center>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <table style="margin-top: 10px; width: 900px">
          <thead>
            <tr>
              <td colspan="1">ข้อมูล {{ config.oilType_name }}</td>
              <td v-if="config.station_id == ''" colspan="2">
                จากตันทางโรงกลั่น ทั้งหมด ( IRPC, SPRC, TOP, PTTGC, ESSO, BCP )
              </td>
              <td v-else colspan="3">
                จากตันทางโรงกลั่น {{ config.station_name }}
              </td>
            </tr>
            <tr>
              <td colspan="4">
                ประจำวันที่ {{ displayDate(config.startDate) }} - {{ displayDate(config.endDate) }}
              </td>
            </tr>
            <tr>
              <td style="width: 225px">
                 {{ $t("totalOil") }} <br />{{ formatNumber(getOilVolumeRefinery("")) }}
                ลิตร
              </td>
              <td style="width: 225px">
                {{ $t("TotalIsExciseRate") }}<br />{{
                  formatNumber((Number(totalOilType)).toFixed(2))
                }}
                บาท
              </td>
              <td style="width: 225px">
                {{ $t("PercentOfLost") }} <br />{{
                  formatNumber((Number(totalOilType) * 0.01).toFixed(2))
                }}
                บาท
              </td>
            </tr>
          </thead>
        </table>
        <hr style="margin: 20px; width: 900px" />
        <table style="margin-top: 10px; width: 900px">
          <thead>
            <tr v-if="config.station_id == ''">
              <td style="width: 50px">
                โรงกลั่น<br /><br /><br /><br /><br /><br />
              </td>
              <td style="width: 60px">
                {{ REFINERY_NAME.IRPC }}<br />
                {{ REFINERY_NAME.SPRC }}<br />
                {{ REFINERY_NAME.TOP }}<br />
                {{ REFINERY_NAME.PTTGC }}<br />
                {{ REFINERY_NAME.ESSO }}<br />
                {{ REFINERY_NAME.BCP }}<br />
              </td>
              <td>
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.IRPC)) }} ลิตร
                <br />
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.SPRC)) }} ลิตร
                <br />
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.TOP)) }} ลิตร
                <br />
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.PTTGC)) }} ลิตร
                <br />
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.ESSO)) }} ลิตร
                <br />
                {{ formatNumber(getOilVolumeRefinery(REFINERY_ID.BCP)) }} ลิตร
                <br />
              </td>
            </tr>
            <tr v-else>
              <td style="width: 110px">
                โรงกลั่น {{ config.station_name }}<br />
              </td>
              <td>
                {{ formatNumber(getOilVolumeRefinery(config.station_id)) }} ลิตร
                <br />
              </td>
            </tr>
            <tr>
              <td colspan="4"><div class="m-5"></div></td>
            </tr>
            <tr style="margin-top: 0px">
              <td colspan="4" style="border: 1px solid">
                <DirectTree style="height: 700px; width: 900px" />
              </td>
            </tr>
          </thead>
        </table>
        <br /><br /><br />
        <table style="width: 900px">
          <thead>
            <tr>
              <td colspan="2" style="border: 1px solid">
                <h6 class="m-2 active">กราฟวงกลม</h6>
                <br />
                <RadarBar style="height: 350px; width: 450px" />
              </td>
              <td colspan="2" style="border: 1px solid">
                <h6 class="m-2 active">กราฟดวงอาทิตย์</h6>
                <br />
                <SunBurst style="height: 350px; width: 450px; padding: 20px" />
              </td>
            </tr>
          </thead>
        </table>
        <table>
          <thead>
            <tr>
              <td colspan="4" style="border: 1px solid">
                <h6 class="m-2 active">แผนภูมิยอดรวมน้ำมัน</h6>
                <br />
                <StackedColumnChart
                  :dataStack="report"
                  style="height: 330px; width: 904px"
                />
              </td>
            </tr>
            <tr>
              <td colspan="4" style="border: 1px solid">
                <h6 class="m-2 active">กราฟเส้น</h6>
                <br />
                <HighlightingChart
                  :dataLine="report"
                  style="height: 330px; width: 904px"
                />
              </td>
            </tr>
            <tr>
              <td colspan="4" style="border: 1px solid">
                <h6 class="m-2 active">แผนภูมิประเภทน้ำมัน</h6>
                <br />
                <OilTypeStackedColumnChart
                  :dataStack="report"
                  style="height: 330px; width: 904px"
                />
              </td>
            </tr>
          </thead>
        </table>

        <vs-table style="margin-top: 50px; width: 900px" :data="report">
          <template slot="header">
            <h6 class="m-2 active">
              {{ $t("ShipmentTable.Shipment") }}
            </h6>
          </template>
          <template slot="thead">
            <vs-th>
              {{ $t("TankerTable.Id") }}
            </vs-th>
            <vs-th>
              {{ $t("TankerTable.TankerName") }}
            </vs-th>
            <vs-th>
              {{ $t("TankerTable.OilType") }}
            </vs-th>
            <vs-th>
              {{ $t("TankerTable.TransferVolume") }}
            </vs-th>
            <vs-th>
              {{ $t("TankerTable.TransferTotalVolume") }}
            </vs-th>
            <vs-th sort-key="departed_at_formatted_be">
              {{ $t("TankerTable.TransferStart") }}
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">
                {{ indextr + 1 }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.mmsi">
                {{ data[indextr].vessel.name }}
              </vs-td>

              <vs-td :data="data[indextr].oil_type">
                {{ data[indextr].oil_type }}
              </vs-td>

              <vs-td :data="data[indextr].volume">
                {{ data[indextr].volume }}
              </vs-td>

              <vs-td :data="data[indextr].volumes">
                {{ getVolume(data[indextr].volumes) }}
              </vs-td>

              <vs-td>
                {{ data[indextr].departed_at_formatted_be }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </center>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import DirectTree from "@/components/Charts/GreenOil/DirectedTree.vue";
import RadarBar from "@/components/Charts/RadarChart.vue";
import SunBurst from "@/components/Charts/SunBurstChart.vue";
import StackedColumnChart from "@/components/Charts/StackedColumnChart.vue";
import HighlightingChart from "@/components/Charts/HighlightingChart.vue";
import OilTypeStackedColumnChart from "@/components/Charts/DomisticExport/OilTypeStackedColumnChart.vue";
import { formatNumber } from "@/utils/index";
import { REFINERY_NAME, REFINERY_ID } from "../constant/index";
import _ from "lodash";
import moment from "moment"
import { OIL_PRICE } from "@/constant";

export default {
  components: {
    DirectTree,
    RadarBar,
    SunBurst,
    StackedColumnChart,
    HighlightingChart,
    OilTypeStackedColumnChart,
  },
  data() {
    return {
      totalOilType: "",
      config: "",
      formatNumber,
      REFINERY_NAME,
      REFINERY_ID,
    };
  },
  computed: {
    ...mapState({
      oilType: (state) => state.vesselTrip.oilType,
      report: (state) => state.vesselTrip.data,
    }),
  },
  watch: {
    report(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.getReports();
      }
    },
  },
  mounted() {
    // this.$store.dispatch("getOilType");
    this.config = JSON.parse(localStorage.getItem("config"));
    this.getReports();
  },
  created() {},
  methods: {
    getOilPrice() {
      console.log(this.report);
      let totalOilPrice = _.chain(this.report)
        .groupBy("vessel_loads.oil_type_id")
        .map((o, i) => {
          let id = "";
          let volume = 0;
          let data = [];
          let vesselLoads = _.chain(o)
            .map((o) => {
              let vesselLoad = _.get(o, "vessel_loads");
              let oilTypeId = _.chain(vesselLoad)
                .map((o) => {
                  let id = _.get(o, "oil_type_id");
                  let oilCategory = _.find(this.oilType, { id: id });
                  // console.log(oilCategory);
                  if (oilCategory != undefined) {
                    return oilCategory.oil_category_id;
                  } else {
                    return "";
                  }
                })
                .value();

              let oilTypevolume = _.chain(vesselLoad)
                .map((o) => {
                  let volume = _.get(o, "volume");
                  return volume;
                })
                .value();
              return { oilTypeId, oilTypevolume };
            })
            .value();

          _.chain(vesselLoads)
            .map((o) => {
              for (let i = 0; i < o.oilTypeId.length; i++) {
                id = o.oilTypeId[i];
                volume = o.oilTypevolume[i];
                data.push({ id, volume });
              }
            })
            .value();

          let sumOilType = _.chain(data)
            .groupBy("id")
            .map((o) => {
              let id = _.reduce(
                o,
                (vessel, a) => {
                  return _.get(a, "id");
                },
                0
              );
              const price = OIL_PRICE[id] || 1;
              let sumPrice = _.reduce(
                o,
                (sum, a) => {
                  let volumes = _.get(a, "volume");
                  return (sum + Number(volumes) * price) ;
                },
                0
              );

              return { id, sumPrice };
            })
            .value();

          let totalPrice = _.sumBy(sumOilType, "sumPrice");
          this.totalOilType = totalPrice;
          console.log(this.totalOilType); 
        })
        .value();
    },
    async getReports() {
      this.$store.dispatch("getOilType");
      await this.$store.dispatch("getVesselTrip", this.config);
      this.getOilPrice();
      this.$vs.loading({});
      setTimeout(() => {
        this.$vs.loading.close();
      }, 5000);
    },
    displayDate(date) {
      const locale = this.$i18n.locale;
      if (locale == 'th') {
        const newDate = moment(date, 'DD/MM/YYYY').add(543, 'years').format('DD/MM/YYYY');
        return newDate
      }
      return date
    },
    getOilVolumeRefinery(stationId) {
      return this.report
        .filter((value) => {
          if (stationId == "") {
            return true;
          } else if (value.station_id == stationId) {
            return true;
          }
        })
        .reduce((previous, current) => {
          let volumes = _.get(current, "volumes").map((a) => {
            return Number(a);
          });
          return previous + _.sum(volumes);
        }, 0);
    },
    getVolume(data) {
      let value = _.chain(data)
        .map((a) => {
          return Number(a);
        })
        .sum();
      return formatNumber(value);
    },
    getCapacity(mmsi) {
      const data = _.find(this.mpTankerData, { mmsi });
      if (data == undefined || data.capacity == null) {
        return 0;
      } else {
        return data.capacity;
      }
    },
    print() {
      this.hide = true;
      setTimeout(() => {
        this.hide = false;
        window.print();
      }, 150);
    },
  },
};
</script>
<style>
.scroll-area--customizer-report {
  height: calc(100% - 6rem);
  width: 950px;
}

@media print {
  #selecttime {
    display: none;
  }
}
.active {
  font-weight: bold;
}
</style>